/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-22 21:35:02
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo, Integer} from "src/types/base";
export declare namespace SynthesizeReportDOI {

	export interface RowDataI {
		
	}

	export interface QueryRowDataParamsI extends PageDo {
        ids?: number[]
        start_time?: Integer
        end_time?: Integer
        cn?: string
	}


}
export default class SynthesizeReportApi {
	static async searchDayList(params: SynthesizeReportDOI.QueryRowDataParamsI):Promise<ResultPageDo<any[],{ key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/point/forms/synthesize_daily/get', {
            ...params,
            cn: '2011'
        })
    }
    static async searchWeekList(params: SynthesizeReportDOI.QueryRowDataParamsI):Promise<ResultPageDo<any[],{ key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/point/forms/synthesize_weekly/get', {
            ...params,
            cn: '2011'
        })
    }
    static async searchMonthList(params: SynthesizeReportDOI.QueryRowDataParamsI):Promise<ResultPageDo<any[],{ key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/point/forms/synthesize_monthly/get', {
            ...params,
            cn: '2011'
        })
    }
    static async searchYearList(params: SynthesizeReportDOI.QueryRowDataParamsI):Promise<ResultPageDo<any[],{ key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/point/forms/synthesize_yearly/get', {
            ...params,
            cn: '2011'
        })
    }
    static async export(type: string): Promise<Result<{download_url: string}>> {
        let url = ''
        switch (type) {
            case '日报':
                url = '/monitor/synthesize/daily/export'
                break;
            case '周报':
                url = '/monitor/synthesize/weekly/export'
                break;
            case '月报':
                url = '/monitor/synthesize/monthly/export'
                break;
            case '年报':
                url = '/monitor/synthesize/yearly/export'
                break;
        }
        return Api.post(url);
    }
}